import { yupResolver } from "@hookform/resolvers/yup";
import { FunctionComponent, useEffect, useMemo } from "react";
import {
  Controller,
  ControllerRenderProps,
  FieldError,
  useForm,
} from "react-hook-form";
import { mixed, object } from "yup";
import { ErrorText } from "../../../../../../components/billing";
import { Flex } from "../../../../../../components/layout";
import { Field } from "../../../../../../store/launch-configurations/models/internal/field";
import MultiTextField from "../../../common/multi-lingual-text";
interface IToggleCustomFieldProps {
  field: ControllerRenderProps<Field.Field<string>, "typeDetails">;
  error: FieldError | undefined;
}

const ToggleCustomField: FunctionComponent<IToggleCustomFieldProps> = ({
  error,
  field,
}) => {
  const { control, watch } = useForm<{ field: Record<string, string> }>({
    resolver: useMemo(
      () =>
        yupResolver(
          object().shape({
            availableOptions: mixed(), // TODO
          })
        ),
      []
    ),
  });

  useEffect(() => {
    const sub = watch((data) => field.onChange(data.field));
    return () => sub.unsubscribe();
  }, [watch, field.onChange]);

  return (
    <div>
      <Flex>
        <Controller
          control={control}
          name="field"
          defaultValue={{}}
          render={({ field }) => <MultiTextField {...field} />}
        />
      </Flex>

      {error ? <ErrorText>{error.message}</ErrorText> : null}
    </div>
  );
};

export default ToggleCustomField;
